//  Copyright (c) 2014 Readium Foundation and/or its licensees. All rights reserved.
//
//  Redistribution and use in source and binary forms, with or without modification,
//  are permitted provided that the following conditions are met:
//  1. Redistributions of source code must retain the above copyright notice, this
//  list of conditions and the following disclaimer.
//  2. Redistributions in binary form must reproduce the above copyright notice,
//  this list of conditions and the following disclaimer in the documentation and/or
//  other materials provided with the distribution.
//  3. Neither the name of the organization nor the names of its contributors may be
//  used to endorse or promote products derived from this software without specific
//  prior written permission.

import $ from 'jquery';
import URI from 'urijs';
import ContentTypeDiscovery from './discover_content_type';
import PlainResourceFetcher from './plain_resource_fetcher';
import FileSystem from '@axisnow/storage/filesystem';
import utils from '@axisnow/util/utils';

var EncryptedResourceFetcher = function(parentFetcher) {
  var self = this;

  PlainResourceFetcher.call(this, parentFetcher);

  var fileSystem = new FileSystem();
  var _encryptionHandler;

  //$.extend(self, new PlainResourceFetcher (parentFetcher, baseUrl));

  //Internal Functions

  var parentFetchFileContentsText = this.fetchFileContentsText;
  var parentFetchFileContentsBlob = this.fetchFileContentsBlob;

  function getDecryptionCallback(relativePathname, callback, converter) {
    return new Promise(function(resolve, reject) {
      var decryptionFunction;
      if (_encryptionHandler) {
        decryptionFunction = parentFetcher.getDecryptionFunctionForRelativePath(relativePathname);
        if (typeof decryptionFunction !== 'undefined') {
          resolve(function(unencrypted) {
            decryptionFunction(unencrypted, function(decrypted) {
              if (typeof converter !== 'undefined' && typeof decrypted !== 'undefined') {
                decrypted = converter(decrypted);
              }
              callback(decrypted);
            });
          });
          return;
        }
      }
      reject(callback);  /** THIS CAUSES A WARNING IN BROWSER CONSOLE THAT PROMISE IS REJECTED WITH A NON-ERROR, THIS IS ON PURPOSE TO END THE PROMISE CHAIN AN PREVENT UNDESIRED SIDE EFFECTS DUE ENCRYPTED DATA */
    });
  }

  function fetchAsUint8Array(pathRelativeToPackageRoot) {
    return new Promise(function(resolve, reject) {
      if (typeof pathRelativeToPackageRoot === 'undefined') {
        throw 'Fetched file relative path is undefined!';
      }

      var fileUrl = self.resolveURI(pathRelativeToPackageRoot);

      var xhr = new XMLHttpRequest();
      xhr.open('GET', fileUrl, true);
      xhr.timeout = $.ajaxSettings.timeout;
      xhr.responseType = 'arraybuffer';
      xhr.onerror = function() {
        reject();
      };
      xhr.ontimeout = function() {
        reject();
      };
      xhr.onload = function(loadEvent) {
        resolve(new Uint8Array(xhr.response));
      };

      xhr.send();
    });
  }

  var fetchEncrypted = function(callback, onerror, pathRelativeToPackageRoot, type) {
    var path = new URI(parentFetcher.getEbookURL()).filename() + '/' + pathRelativeToPackageRoot;
    path = new URI(path);

    fileSystem
      .getFile(path.directory(), path.filename(), type)
      .then(function(result) {
        callback(new Uint8Array(result));
      })
      .catch(function() {
        utils
          .isOnline()
          .then(function() {
            fetchAsUint8Array(pathRelativeToPackageRoot)
              .then(function(result) {
                callback(result);
              })
              .catch(function(error) {
                onerror(error);
              });
          })
          .catch(function(error) {
            onerror(error);
          });
      });
  };

  var fetchUnencrypted = function(callback, onerror, pathRelativeToPackageRoot, type) {
    var path = new URI(parentFetcher.getEbookURL()).filename() + '/' + pathRelativeToPackageRoot;
    path = new URI(path);

    fileSystem
      .getFile(path.directory(), path.filename(), type)
      .then(function(result) {
        callback(result);
      })
      .catch(function(error) {
        utils
          .isOnline()
          .then(function() {
            if (type === 'text') {
              parentFetchFileContentsText(pathRelativeToPackageRoot, callback, onerror);
            } else {
              parentFetchFileContentsBlob(pathRelativeToPackageRoot, callback, onerror);
            }
          })
          .catch(function(error) {
            onerror(error);
          });
      });
  };

  //Public API

  this.setEncryptionHandler = function(encryptionHandler) {
    _encryptionHandler = encryptionHandler;
  };

  this.fetchFileContentsText = function(pathRelativeToPackageRoot, fetchCallback, onerror) {
    console.log('EncryptedResourceFetcher');

    var converter = function(data) {
      return _encryptionHandler.utils.bufferToUtf8(data);
    };

    return getDecryptionCallback(pathRelativeToPackageRoot, fetchCallback, converter)
      .then(function(callback) {
        fetchEncrypted(callback, onerror, pathRelativeToPackageRoot, 'arrayBuffer');
      })
      .catch(function(callback) {
        fetchUnencrypted(callback, onerror, pathRelativeToPackageRoot, 'text'); /** THIS CATCH IS ON PURPOSE AND RELATED TO WHY getDecryptionCallback() rejects with a non-error */
      });
  };

  this.fetchFileContentsBlob = function(pathRelativeToPackageRoot, fetchCallback, onerror) {
    console.log('EncryptedResourceFetcher');

    var converter = function(data) {
      return new Blob([data.buffer], {
        type: ContentTypeDiscovery.identifyContentTypeFromFileName(pathRelativeToPackageRoot),
      });
    };

    return getDecryptionCallback(pathRelativeToPackageRoot, fetchCallback, converter)
      .then(function(callback) {
        fetchEncrypted(callback, onerror, pathRelativeToPackageRoot, 'arrayBuffer');
      })
      .catch(function(callback) {
        fetchUnencrypted(callback, onerror, pathRelativeToPackageRoot, 'arrayBuffer');  /** THIS CATCH IS ON PURPOSE AND RELATED TO WHY getDecryptionCallback() rejects with a non-error */
      });
  };
};

export default EncryptedResourceFetcher;
